import { Fragment } from "react";

import { prop, define } from "@/components/builder/utils";

import BasePreview from "../../../../base";

import { StatusActions } from "./hook";

function FormConsentInstructionsContainerPreview({ children, ...props }) {
  return <BasePreview {...props} customActions={<StatusActions />}>
    <div>
      {children}
    </div>
  </BasePreview>
}

export default define('form-consent-instructions-container', FormConsentInstructionsContainerPreview, Fragment)
  .shared(prop.share('FormConsentContainer', 'form-consent-instructions-container'))
  .property(prop.predefined.customClass())
  .property(...prop.predefined.borders())
  .property(...prop.predefined.appearance())
  .property(...prop.predefined.typography())
  .defaultUtilities([
    '[[data-status=checked]_&]',
    '[[data-status=error]_&]',
  ])
  .defaultProps({
    space: {
      padding: "p-1",
    },
    background: {
      color: {
        default: null,
        "[[data-status=checked]_&]": "green-100",
        "[[data-status=error]_&]": "red-100",
      },
    },
    border: {
      color: {
        default: "gray-400",
        "[[data-status=checked]_&]": "green-100",
        "[[data-status=error]_&]": "red-100",
      },
      width: {
        default: { border: "1" },
        "[[data-status=checked]_&]": { border: "1" },
        "[[data-status=error]_&]": { border: "1" },
      },
      radius: {
        rounded: "sm",
      },
    },
  })
  .build()
